"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slider.default;
  }
});
Object.defineProperty(exports, "defaultValueReducer", {
  enumerable: true,
  get: function get() {
    return _Slider.defaultValueReducer;
  }
});

var _Slider = _interopRequireWildcard(require("./Slider"));